import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { DefaultBanner, DefaultURLPattern } from '../../../core/services/constant';
import { FeedItem } from '../../../core/models/news/feed-item';
import { News } from '../../../core/models/news/news';
import { RssFeedService } from '../../../core/services/api/rss-feed.service';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    standalone: false
})
export class NewsComponent implements OnChanges {
  @Input() campaignId: number;
  @Input() rssUrl: string;
  @Input() isCreator: boolean;
  @Input() isAddNews: boolean = false;
  @Input() isLoading: boolean;
  @Output() getDataChange = new EventEmitter<any>();
  @Output() valueOnChange = new EventEmitter<any>();
  @Output() getRssValueOnChange = new EventEmitter<any>();

  rssParams = {
    currentPage: 1,
    take: 3,
  };

  defaultBanner = DefaultBanner;
  form: UntypedFormGroup;
  showFormError: boolean = false;
  rssData: News;
  rssFeedItems: FeedItem[] = [];
  rssTotal: number = 0;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private rssFeedService: RssFeedService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if ('rssUrl' in changes && this.rssUrl) this.getRssFeedData();
  }

  loadMore() {
    this.rssParams.currentPage++;
    this.getRssFeedData();
  }

  getRssFeedData() {
    this.isLoading = true;

    this.rssFeedService
      .getFeedContent(this.rssUrl)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((data) => {
        this.rssData = data;
        this.getRssItems();
      });
  }

  getRssItems() {
    let startIndex = 0;
    let endIndex = this.rssParams.currentPage * this.rssParams.take;
    let items: FeedItem[] = this.rssData.items;
    this.rssTotal = items.length;
    this.rssFeedItems = items.slice(startIndex, endIndex);
  }

  cancel() {
    this.isAddNews = !this.isAddNews;
  }

  addNews() {
    this.isAddNews = !this.isAddNews;

    if (this.isAddNews) this.buildForm();
  }

  buildForm() {
    this.form = this.formBuilder.group({
      rssUrl: [this.rssUrl, Validators.pattern(DefaultURLPattern)],
    });
  }

  submit() {
    if (this.form.invalid) {
      this.showFormError = true;
      return;
    }

    this.isLoading = true;
    this.rssData = null;
    this.rssFeedItems = [];
    this.rssTotal = 0;
    this.cancel();
    this.valueOnChange.emit(this.form.value.rssUrl);
  }

  openUrl(url: string) {
    window.open(url);
  }
}
